import { Controller } from 'stimulus';
import toArray from '../helpers/toArray';

class Select extends Controller {
  connect() {
    this.isExpanded = false;
    this.name = this.data.get('name');

    const selectedOption = this.selectedOption();

    this.value = selectedOption ? selectedOption.dataset.key : '';

    this.onDocumentKeyUpBound = this.onDocumentKeyUp.bind(this);

    document.addEventListener('keyup', this.onDocumentKeyUpBound);
  }

  disconnect() {
    document.removeEventListener('keyup', this.onDocumentKeyUpBound);
  }

  onDocumentKeyUp(event) {
    if (this.isExpanded && event.key === 'Escape') {
      this.isExpanded = false;
      this.handleA11Y(false);
    }
  }

  onWindowClick(event) {
    // If click is outside element
    if (!this.element.contains(event.target)) {
      this.isExpanded = false;
      this.handleA11Y(false);
    }
  }

  onOpenList() {
    this.isExpanded = !this.isExpanded;

    this.handleA11Y();
  }

  handleA11Y(changeFocus = true) {
    this.toggleTarget.setAttribute('aria-expanded', this.isExpanded);
    this.listTarget[this.isExpanded ? 'removeAttribute' : 'setAttribute']('hidden', 'hidden');

    const selected = this.listTarget.querySelector(`[data-key="${this.value}"]`);
    const currentSelected = toArray(this.listTarget.querySelectorAll('[aria-selected]'));

    if (changeFocus) {
      Select.focusOn(this.isExpanded ? this.listTarget : this.toggleTarget);
    }

    currentSelected.forEach((item) => {
      item.setAttribute('aria-selected', 'false');
    });

    if (selected) {
      selected.setAttribute('aria-selected', 'true');
    }

    this.toggleTarget.style.minWidth = this.isExpanded
      ? `${this.listTarget.offsetWidth}px`
      : 0;
  }

  static focusOn(target) {
    target.focus();
  }

  selectedOption() {
    return this.element.querySelector('[aria-selected="true"]');
  }

  forceOptionSelect() {
    const selectedOption = this.selectedOption();

    if (selectedOption) {
      this.value = selectedOption.dataset.key;

      this.onOptionSelect({
        target: selectedOption,
      }, true);
    }
  }

  onOptionSelect(event, silent = false) {
    this.isExpanded = false;

    this.selectOption(event.target);

    const dispatchedEvent = new CustomEvent('change', {
      detail: {
        name: this.name,
        value: this.value,
      },
    });

    if (!silent) {
      this.element.dispatchEvent(dispatchedEvent);
    }

    this.syncOtherSelectBoxes(event.target.dataset.key);
  }

  reset() {
    this.value = '';
    const toggleTextSpan = this.toggleTarget.querySelector('span');
    toggleTextSpan.textContent = toggleTextSpan.dataset.defaultLabel;
    this.inputFieldTarget.value = '';
  }

  selectOption(target, changeFocus = true) {
    const { dataset } = target;

    this.value = dataset.key;

    this.toggleTarget.querySelector('span').textContent = dataset.text;
    this.inputFieldTarget.value = dataset.key;

    this.handleA11Y(changeFocus);
  }

  syncOtherSelectBoxes(key) {
    const name = this.element.getAttribute('data-select-name');
    const selectBoxesForName = document.querySelectorAll(`[data-select-name="${name}"]`);

    selectBoxesForName.forEach((selectBox) => {
      if (selectBox === this.element) {
        return;
      }

      const controller = this.application.getControllerForElementAndIdentifier(selectBox, 'select');

      const option = selectBox.querySelector(`[data-key="${key}"]`);

      if (option) {
        controller.selectOption(option, false);
      }
    });
  }
}

Select.targets = [
  'toggle',
  'list',
  'inputField',
];

export default Select;
